var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeisureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    x: "0px",
    y: "0px",
    id: "svg92",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs15"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.999675,-974.36896)",
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 47.923373,978.73682 a 1.5872081,1.5872081 0 0 0 -1.505457,1.0861 l -3.977167,11.93594 c -0.739131,-0.52282 -1.637613,-0.83232 -2.603423,-0.83232 -2.489348,0 -4.537982,2.04872 -4.537982,4.53729 0,2.48857 2.048634,4.53727 4.537982,4.53727 2.26267,0 4.159891,-1.69274 4.486679,-3.86977 a 1.5873546,1.5873546 0 0 0 0.04219,-0.10814 l 4.701303,-14.1124 h 11.843443 l -3.298012,9.89947 c -0.752214,-0.55411 -1.677892,-0.88372 -2.675308,-0.88372 -2.489348,0 -4.537541,2.04872 -4.537541,4.53729 0,2.48857 2.048193,4.53727 4.537541,4.53727 2.163738,0 3.99319,-1.54787 4.434934,-3.58692 a 1.5872081,1.5872081 0 0 0 0.181843,-0.39099 l 5.064106,-15.19709 a 1.5872081,1.5872081 0 0 0 -1.506634,-2.08928 z",
    id: "path84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisureIcon);
export default __webpack_public_path__ + "static/media/leisure-icon.9b35828c.svg";
export { ForwardRef as ReactComponent };